import { z } from 'zod'

export const citationSpanSchema = z.object({
  bbox: z.array(z.array(z.number())).optional(),
  block_id: z.union([z.string(), z.number()]).optional(),
  lines: z.array(z.number()).optional(),
})

export const citationTargetSchema = z.object({
  evidence_id: z.string().optional(),
  page: z.number(),
  quote: z.string(),
  span: citationSpanSchema.optional(),
  resolution: z.enum(['exact', 'coarse', 'failed']),
})

export const citationSchema = z
  .object({
    doc_id: z.string(),
    kind: z.enum(['page', 'section', 'row', 'web']),
    marker: z.number().optional(),
    page: z.number().optional(),
    section_path: z.union([z.string(), z.array(z.string())]).optional(),
    sheet: z.string().optional(),
    rows: z.array(z.number()).optional(),
    snippet: z.string().optional(),
    snippets: z.array(z.string()).optional(),
    targets: z.array(citationTargetSchema).optional(),
    // Server's record of which target each occurrence of the marker was bound
    // to. The browser rebinds from the quote next to the marker it rendered,
    // since markdown splits an answer into text nodes with no shared ordinal.
    occurrence_targets: z.array(z.number()).optional(),
    span: citationSpanSchema.optional(),
    span_resolution: z.enum(['exact', 'partial', 'coarse', 'failed', 'resolved']).optional(),
    title: z.string().optional(),
    url: z.string().url().optional(),
    file_name: z.string().optional(),
    preview_url: z.string().optional(),
    derived_url: z.string().optional(),
  })
  .superRefine((citation, ctx) => {
    if (citation.kind === 'web' && !citation.url) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'web citations require a url',
        path: ['url'],
      })
    }
  })

export const citationsSchema = z.array(citationSchema)
